module.exports = __webpack_public_path__ + "static/media/marathon.e3c9ee33.svg";